module.exports = __webpack_public_path__ + "static/media/larr.083a932f.webp";